// extracted by mini-css-extract-plugin
var _1 = "CreateAccount-module__content___t0aaX";
var _2 = "CreateAccount-module__header___vQHxM";
var _3 = "CreateAccount-module__logo___ZfhNJ";
export { _1 as "content", _2 as "header", _3 as "logo" }
